




















import {Vue, Component, Prop} from "vue-property-decorator";
import Input from "@/components/Form/elements/Input.vue";


@Component({
  components: {Input}
})
export default class ResetPasswordForm extends Vue {
  public name: string = "ResetPasswordForm";

  @Prop({required: false, default: false})
  public reset!: boolean;

  @Prop({required: false, default: null})
  public errors!: any;

  protected showErrors = true;

  protected email: string = "";
  protected password: string = "";
  protected password_confirmation: string = '';

  private validationErrors(index: string): any {

    if (this.errors && this.errors.hasOwnProperty(index)) {

      return this.errors[index];

    }

    return [];

  }

  public onSubmit(): void {

    this.$emit("submit", {
      email: this.email,
      password: this.password,
      password_confirmation: this.password_confirmation
    });

    this.showErrors = false;

    if (this.reset) {
      this.email = '';
      this.password = '';
      this.password_confirmation = '';

    }
  }

}
